import { Component, Input, output } from '@angular/core';
import { NgOptimizedImage, NgClass } from '@angular/common';
import { Button } from '../button/button';

type TitleType = 'trash' | 'reset' | 'terminal';

@Component({
  selector: 'app-table-buttons',
  imports: [NgOptimizedImage, Button, NgClass],
  templateUrl: './table-buttons.html',
  styleUrl: './table-buttons.scss',
})
export class TableButtons {
  @Input() title: TitleType | string = 'trash';

  clickEvent = output<void>();

  onCLick() {
    this.clickEvent.emit();
  }

  capitalize(str: string) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  isTitleType(value: any): boolean {
    return value === 'trash' || value === 'reset';
  }
}
